"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersController = exports.EOrderControllerEvents = exports.EOrdersControllerStatus = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const shared_1 = require("../network/shared");
const misc_1 = require("../utils/misc");
const asyncRequestService_1 = require("../utils/misc/asyncRequestService");
var EOrdersControllerStatus;
(function (EOrdersControllerStatus) {
    EOrdersControllerStatus["IDLE"] = "IDLE";
    EOrdersControllerStatus["ACTIVE"] = "ACTIVE";
    EOrdersControllerStatus["PAUSED"] = "PAUSED";
})(EOrdersControllerStatus = exports.EOrdersControllerStatus || (exports.EOrdersControllerStatus = {}));
var EOrderControllerEvents;
(function (EOrderControllerEvents) {
    EOrderControllerEvents["UPDATE"] = "UPDATE";
    EOrderControllerEvents["ERROR"] = "ERROR";
})(EOrderControllerEvents = exports.EOrderControllerEvents || (exports.EOrderControllerEvents = {}));
class OrdersController {
    constructor(params) {
        this.status = EOrdersControllerStatus.IDLE;
        this.isFirstInit = true;
        this.pollingService = new asyncRequestService_1.PollingService();
        this.setBalances = (params) => {
            this.userBalance = params.balances;
        };
        if (this.constructor === OrdersController) {
            throw new Error("Abstract classes can't be instantiated.");
        }
        const { wsClient, wsQueueInterval, cacheManager } = params;
        this.wsQueueInterval = wsQueueInterval;
        this.wsClient = wsClient;
        this._emitter = new eventemitter3_1.default();
        if (cacheManager) {
            this.cacheManager = cacheManager;
        }
    }
    static load(params) { }
    on(eventName, callback, context) {
        this._emitter.on(eventName, callback, context);
    }
    off(eventName, callback, context) {
        this._emitter.off(eventName, callback, context);
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.status !== EOrdersControllerStatus.IDLE)
                return;
            this.status = EOrdersControllerStatus.ACTIVE;
            if (!this.isFirstInit) {
                const [, , balances] = yield Promise.all([this.wsClient.reinit(), this.ordersList.reset(), this.getBalances({
                        restClient: this.restClient
                    })]);
                this.setBalances({ balances: balances.balances });
            }
            this.initListeners({
                setInitialSubscriptions: true
            });
            this.isFirstInit = false;
        });
    }
    initListeners(params) {
        const { setInitialSubscriptions } = params;
        this._emitter.emit(EOrderControllerEvents.UPDATE, {
            actualState: Object.assign(Object.assign({}, this.ordersList.data), { balances: this.userBalance.data }),
            changedState: Object.assign(Object.assign({}, this.ordersList.data), { balances: this.userBalance.data })
        });
        this.startListen();
        if (setInitialSubscriptions)
            this.setInitialSubscriptions();
        this.startPolling();
        this.wsClient.on(shared_1.EWsEventsTypes.CONNECTION_BROKEN, this.handleErrors.bind(this));
    }
    startListen() {
        this.subscribeDueToData(this.defaultSubscriptionPairs, []);
        this.wsClient.on(shared_1.EWsEventsTypes.MESSAGE_RECIEVED, this.handleEvents, this);
        this.wsClient.initQueue(this.wsQueueInterval);
    }
    handleErrors(message) {
        this._emitter.emit(EOrderControllerEvents.ERROR);
    }
    handleEvents(messages) {
        // update market with messages
        this.marketDataInstance.update({
            events: messages,
            exchangeInfo: this.exchangeInfo
        });
        // update balances with messages and market data
        this.userBalance.update({
            events: messages,
            marketData: this.marketDataInstance.data,
        });
        const isHasUpdates = this.isHasUpdates(messages);
        // update OrderList with messages and market data
        // TODO: use filtered messages from isHasUpdates method
        this.ordersList.update({
            marketData: this.marketDataInstance.data,
            events: isHasUpdates ? messages : []
        });
        //TODO: unsubscribe/resubscribe on pause/continue
        const balanceData = this.userBalance.data;
        let assetsUpdateStats = balanceData.assetsUpdateStats;
        if ('assetsUpdateStats' in this.ordersList) {
            assetsUpdateStats = (0, misc_1.mergeAssetStats)(balanceData.assetsUpdateStats, this.ordersList.assetsUpdateStats);
            this.ordersList.clearSubscriptionsList();
        }
        const pairsToSubscribe = this.createQuotePairs({
            assetIds: Array.from(assetsUpdateStats.assetsNew).map(asset => asset[0]),
            exchangeInfo: this.exchangeInfo
        });
        const pairsToUnsubscribe = this.createQuotePairs({
            assetIds: Array.from(assetsUpdateStats.assetsNull).map(asset => asset[0]),
            exchangeInfo: this.exchangeInfo
        });
        this.subscribeDueToData(pairsToSubscribe.quotes, pairsToUnsubscribe.quotes.filter(item => {
            return !this.defaultSubscriptionPairs.map(defaultItem => {
                return defaultItem.pair;
            }).includes(item.pair);
        }));
        this._emitter.emit(EOrderControllerEvents.UPDATE, {
            actualState: Object.assign(Object.assign({}, this.ordersList.data), { balances: this.userBalance.data }),
            changedState: Object.assign(Object.assign({}, this.ordersList.data), { balances: this.userBalance.data })
        });
    }
    pause() {
        if (this.status === EOrdersControllerStatus.PAUSED)
            return;
        this.stopPolling();
        if (this.status !== EOrdersControllerStatus.IDLE)
            this.status = EOrdersControllerStatus.PAUSED;
        this.wsClient.off(shared_1.EWsEventsTypes.MESSAGE_RECIEVED);
        this.wsClient.stopQueue();
    }
    continue() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.status !== EOrdersControllerStatus.PAUSED)
                return;
            this.status = EOrdersControllerStatus.ACTIVE;
            yield this.ordersList.reset();
            this.initListeners({
                setInitialSubscriptions: false
            });
        });
    }
    stop() {
        // if (this.status === EOrdersControllerStatus.IDLE) return
        this.status = EOrdersControllerStatus.IDLE;
        this.pause();
        this.wsClient.deactivate();
        this.wsClient.off(shared_1.EWsEventsTypes.CONNECTION_BROKEN);
    }
    stopPolling() {
        this.pollingService.pause();
    }
    retryOnError() { }
    get marketData() {
        return this.marketDataInstance.data;
    }
    static getInitialData(...args) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    get data() {
        return Object.assign(Object.assign({}, this.ordersList.data), { balances: this.userBalance.data });
    }
    delFromCache(key) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cacheManager) {
                this.cacheManager.del(key);
                return true;
            }
            return false;
        });
    }
    setToCache(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cacheManager) {
                this.cacheManager.set(key, value);
                return true;
            }
            return false;
        });
    }
    getFromCache(key) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cacheManager) {
                return this.cacheManager.get(key);
            }
            return undefined;
        });
    }
}
exports.OrdersController = OrdersController;
